import debounce from "lodash/debounce";

class Footer {
  constructor(footer) {
    this.footer = footer;
    this.setFooterHeight();
    this.events();
  }

  events() {
    window.addEventListener(
      "resize",
      debounce(() => {
        this.setFooterHeight();
      }, 250),
    );
  }

  setFooterHeight() {
    document
      .querySelector("body")
      .style.setProperty("--footer-height", `${this.footer.offsetHeight}px`);
  }
}

export default Footer;
